import React, { useState } from 'react';
import DateMultiSelect from './DateMultiSelect';

const STATUS_CATEGORY_STYLE = {
  done: { color: 'var(--green)', bg: 'rgba(16, 185, 129, 0.15)' },
  progress: { color: 'var(--blue-light, #60a5fa)', bg: 'rgba(59, 130, 246, 0.15)' },
  blocked: { color: 'var(--red-light, #f87171)', bg: 'rgba(239, 68, 68, 0.18)' },
  other: { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.15)' },
};

// Khoảng cách chỉnh sửa (Levenshtein) — để khoan dung lỗi gõ chính tả (vd "Deplay" thay vì "Delay").
function levenshtein(a, b) {
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i]);
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1]
        : 1 + Math.min(dp[i - 1][j - 1], dp[i - 1][j], dp[i][j - 1]);
    }
  }
  return dp[a.length][b.length];
}

// Không so khớp chuỗi tuyệt đối — chỉ cần đúng ý (xong/triển khai/vướng-tắc-chậm-delay dù gõ sai chính tả).
function classifyStatus(status) {
  const s = String(status || '').toLowerCase().trim();
  if (!s) return 'other';
  if (s.includes('xong')) return 'done';
  if (s.includes('triển khai') || s.includes('trien khai') || s.includes('đang chạy')) return 'progress';
  if (['vướng', 'vuong', 'tắc', 'tac', 'chậm', 'cham'].some((k) => s.includes(k))) return 'blocked';
  if (levenshtein(s, 'delay') <= 2) return 'blocked';
  return 'other';
}

function taskStatusStyle(status) {
  return STATUS_CATEGORY_STYLE[classifyStatus(status)];
}

const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+)/g;
const isUrl = (part) => /^https?:\/\//.test(part);

// Render text nhiều dòng (giữ \n) và biến URL thành link bấm được — dữ liệu Sheet hay dán
// nhiều dòng ghi chú kèm link trong cùng 1 ô.
function renderMultilineText(text) {
  if (!text) return null;
  return String(text).split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {line.split(URL_SPLIT_REGEX).map((part, j) => (
        isUrl(part)
          ? <a key={j} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue-light, #60a5fa)' }}>{part}</a>
          : part
      ))}
    </React.Fragment>
  ));
}

export default function DepartmentViews({ activeView, onNavigate, onOpenModal, onShowToast, troLyData }) {
  // Lọc Nhật Ký Báo Cáo Ngày (Ban Trợ Lý) theo 1 hoặc nhiều ngày được chọn.
  // Mảng rỗng = không lọc, hiển thị tất cả.
  const [selectedLogDates, setSelectedLogDates] = useState([]);

  return (
    <>
        <div id="view-dept-mkt" className={`view-panel ${activeView === 'view-dept-mkt' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-bullhorn" style={{"color":"#c084fc"}}></i> DASHBOARD PHÒNG MARKETING</h2>
                    <p>Virtual BOT Assistant &amp; Pipeline Sản Xuất Video Dược, Quản Trị Quảng Cáo &amp; Tương Tác Nhà Thuốc</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task Marketing</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">VIDEO NGẮN ĐÃ SẢN XUẤT</div>
                    <div className="kpi-main-val" style={{"color":"var(--purple-light)"}}>28 Video</div>
                    <div className="kpi-sub-text" style={{"color":"var(--green)"}}>Tiết kiệm 92 Giờ/Tháng</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CHI PHÍ AI / VIDEO</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>~50 VNĐ</div>
                    <div className="kpi-sub-text">ChatGPT + ElevenLabs</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐƠN HÀNG TỪ MKT</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>185 Triệu</div>
                    <div className="kpi-sub-text">Tỷ lệ chuyển đổi: 4.8%</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TIẾP CẬN NHÀ THUỐC</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>45.000</div>
                    <div className="kpi-sub-text">TikTok &amp; Facebook Reels</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TASKS ĐANG CHẠY</div>
                    <div className="kpi-main-val" style={{"color":"white"}}>4 Tasks</div>
                    <div className="kpi-sub-text">1 Task chờ duyệt BOD</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐỒNG BỘ CSDL chothuoc247</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>100%</div>
                    <div className="kpi-sub-text">Bảng giá &amp; Tồn kho</div>
                </div>
            </div>

            {/*  Workflow 1: Video Batch  */}
            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-video" style={{"color":"var(--purple-light)","marginRight":"6px"}}></i> 1. Pipeline Sản Xuất Batch 10 Video Ngắn Giới Thiệu Sản Phẩm Dược</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Tự động tạo 10 kịch bản -> Voice AI lồng tiếng -> Render video CapCut API</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>Chi phí ~50 VNĐ/Video</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Input Data</div>
                        <div className="step-title">Lấy Dữ Liệu Thuốc</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> CSDL chothuoc247.vn</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: AI Scripting</div>
                        <div className="step-title">Sinh 10 Kịch Bản Hook</div>
                        <div className="step-tool"><i className="fa-solid fa-brain"></i> ChatGPT 4o / Claude</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: Voice &amp; Edit</div>
                        <div className="step-title">Voice AI &amp; Subtitle</div>
                        <div className="step-tool"><i className="fa-solid fa-microphone"></i> ElevenLabs / CapCut</div>
                    </div>
                    <div className="timeline-box" style={{"borderColor":"var(--gold)"}}>
                        <div className="step-tag" style={{"color":"var(--gold)"}}>Bước 4: Human-in-the-loop</div>
                        <div className="step-title">Trưởng Phòng &amp; BOD Duyệt</div>
                        <div className="step-tool"><i className="fa-solid fa-user-check"></i> Approval Gate</div>
                    </div>
                </div>
            </div>

            {/*  Workflow 2: Daily Analytics Bot  */}
            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-chart-pie" style={{"color":"var(--blue-light)","marginRight":"6px"}}></i> 2. Daily Analytics Bot &amp; Đối Soát Doanh Thu Quảng Cáo</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Kéo dữ liệu CPA, ROAS từ TikTok/Facebook Ads và đối chiếu doanh thu chothuoc247.vn</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--blue-light)","fontWeight":"700","background":"rgba(59, 130, 246, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>Chi phí 0 VNĐ (In-house DB)</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Ads API</div>
                        <div className="step-title">Quét Chỉ Số Chiến Dịch</div>
                        <div className="step-tool"><i className="fa-brands fa-tiktok"></i> TikTok/FB Ads API</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: Reconcile</div>
                        <div className="step-title">Đối Soát Doanh Số Bán</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> chothuoc247.vn Database</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: Calculation</div>
                        <div className="step-title">Tính ROAS &amp; Chi Phí / Đơn</div>
                        <div className="step-tool"><i className="fa-solid fa-calculator"></i> Analytics Engine</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 4: Reporting</div>
                        <div className="step-title">Executive Telegram Brief</div>
                        <div className="step-tool"><i className="fa-brands fa-telegram"></i> Telegram Bot Alert</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 03: THU MUA (PROCUREMENT) DASHBOARD        */}
        {/*  ==============================================  */}
        <div id="view-dept-proc" className={`view-panel ${activeView === 'view-dept-proc' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-cart-shopping" style={{"color":"#fb923c"}}></i> DASHBOARD PHÒNG THU MUA</h2>
                    <p>Tối Ưu Phân Bổ PO (NCC1 vs NCC2) &amp; Bảo Vệ Dòng Tiền Ngoài Hóa Đơn VAT</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task Thu Mua</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">TIẾT KIỆM TỪ DEAL RẺ</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>8.4 Triệu</div>
                    <div className="kpi-sub-text">So với giá Baseline</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">NCC ĐÃ TÁCH HĐ VAT</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>12 NCC</div>
                    <div className="kpi-sub-text">100% Khớp dòng tiền</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐƠN PO ĐÃ XỬ LÝ</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>45 Đơn</div>
                    <div className="kpi-sub-text">Tháng 8/2026</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>73 Giờ</div>
                    <div className="kpi-sub-text">Giảm 85% thủ công</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CHI PHÍ TOOL / BOT</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>0 VNĐ</div>
                    <div className="kpi-sub-text">Thuật toán nội bộ</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐƠN CHỜ DUYỆT CHI</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>1 PO</div>
                    <div className="kpi-sub-text">Hàng đợi BOD</div>
                </div>
            </div>

            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-code-fork" style={{"color":"#fb923c","marginRight":"6px"}}></i> Quy Trình Tự Động Phân Bổ PO &amp; Tách Luồng Hóa Đơn VAT</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Tự động ưu tiên NCC1 (Đủ hàng) và chớp deal rẻ NCC2, tính tiền ngoài hóa đơn: <code>Tiền ngoài = (Giá thực - Giá HĐ) * SL</code></div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>0 VNĐ Chi phí</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Safety Stock</div>
                        <div className="step-title">Quét Nhu Cầu Nhập</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> Tồn kho chothuoc247</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: Price Comparison</div>
                        <div className="step-title">So Sánh Giá 2 NCC</div>
                        <div className="step-tool"><i className="fa-solid fa-calculator"></i> PO Optimizer Engine</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: VAT Split</div>
                        <div className="step-title">Tách 2 Luồng Thanh Toán</div>
                        <div className="step-tool"><i className="fa-solid fa-file-invoice-dollar"></i> Tiền ngoài = (Giá thực-Giá HĐ)*SL</div>
                    </div>
                    <div className="timeline-box" style={{"borderColor":"var(--gold)"}}>
                        <div className="step-tag" style={{"color":"var(--gold)"}}>Bước 4: Approval Gate</div>
                        <div className="step-title">Trưởng Phòng &amp; BOD Duyệt</div>
                        <div className="step-tool"><i className="fa-solid fa-signature"></i> 1-Click Approval</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 04: KHO VẬN (LOGISTICS) DASHBOARD          */}
        {/*  ==============================================  */}
        <div id="view-dept-log" className={`view-panel ${activeView === 'view-dept-log' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-warehouse" style={{"color":"#60a5fa"}}></i> DASHBOARD PHÒNG KHO VẬN</h2>
                    <p>Lên Đơn CPN Hàng Loạt, Xuất PDF Tem Nhãn In Nhiệt &amp; Cảnh Báo Tồn An Toàn Dược</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task Kho</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐƠN CPN ĐÃ XUẤT TEM</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>85 Đơn</div>
                    <div className="kpi-sub-text">1 File PDF in nhiệt</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TỶ LỆ GIAO ĐÚNG HẠN</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>98.2%</div>
                    <div className="kpi-sub-text">SLA Chuyển phát nhanh</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">THỜI GIAN TẠO TEM/ĐƠN</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>1.8 giây</div>
                    <div className="kpi-sub-text">Trước đây: 2-3 phút/đơn</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>56 Giờ</div>
                    <div className="kpi-sub-text">Giải phóng thủ kho</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CẢNH BÁO TỒN AN TOÀN</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>1 Mã thuốc</div>
                    <div className="kpi-sub-text">Cần nhập trong 3 ngày</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TỒN KHO CẬN DATE (&lt;M)</div>
                    <div className="kpi-main-val" style={{"color":"var(--red-light)"}}>8 Mã</div>
                    <div className="kpi-sub-text">Đang chạy Flash Deal</div>
                </div>
            </div>

            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-print" style={{"color":"#60a5fa","marginRight":"6px"}}></i> Lên Đơn CPN Hàng Loạt (50-100 Đơn) &amp; Xuất 1 File PDF Tem Nhãn In Nhiệt Dán Thùng</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Kết nối trực tiếp API Chợ Tốt / Đơn vị vận chuyển, tự động tạo mã vận đơn và xuất nhãn in khổ A6</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>0 VNĐ (API CPN)</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Batch Orders</div>
                        <div className="step-title">Gộp 50-100 Đơn Chờ</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> chothuoc247.vn Orders</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: CPN API</div>
                        <div className="step-title">Gọi API Tạo Vận Đơn</div>
                        <div className="step-tool"><i className="fa-solid fa-truck-fast"></i> API Đơn Vị CPN</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: PDF Label</div>
                        <div className="step-title">Xuất 1 File PDF In Nhiệt</div>
                        <div className="step-tool"><i className="fa-solid fa-file-pdf"></i> Khổ A6 Tem Nhiệt</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 4: Physical Work</div>
                        <div className="step-title">Dán Tem &amp; Xuất Kho</div>
                        <div className="step-tool"><i className="fa-solid fa-box"></i> Nhân viên kho (~5 phút)</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 05: HCNS (HR & ADMIN) DASHBOARD            */}
        {/*  ==============================================  */}
        <div id="view-dept-hr" className={`view-panel ${activeView === 'view-dept-hr' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-users-gear" style={{"color":"#f472b6"}}></i> DASHBOARD PHÒNG HÀNH CHÍNH NHÂN SỰ (HCNS)</h2>
                    <p>OCR 2 Mặt CCCD Nhân Sự, Tự Động Hóa Định Mức VPP &amp; Theo Dõi Quy Trình Thử Việc</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task HCNS</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">OCR CCCD ĐÃ XỬ LÝ</div>
                    <div className="kpi-main-val" style={{"color":"var(--pink)"}}>18 Hồ sơ</div>
                    <div className="kpi-sub-text">100% Khớp dữ liệu gốc</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">THỜI GIAN OCR / BỘ</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>3.2 giây</div>
                    <div className="kpi-sub-text">Tự động nhận diện lóa/mờ</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐỊNH MỨC VPP LARK BASE</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>Tự Động</div>
                    <div className="kpi-sub-text">QR Code Ticketing</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>47 Giờ</div>
                    <div className="kpi-sub-text">Giảm 80% nhập liệu</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TUYỂN DỤNG DƯỢC SĨ</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>2 Vị trí</div>
                    <div className="kpi-sub-text">Đang phỏng vấn</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CHI PHÍ AI / HỒ SƠ</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>~15 VNĐ</div>
                    <div className="kpi-sub-text">Gemini 1.5 Flash Vision</div>
                </div>
            </div>

            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-id-card" style={{"color":"#f472b6","marginRight":"6px"}}></i> CCCD OCR Vision Portal — Tự Động Trích Xuất &amp; Đối Chiếu Hồ Sơ Nhân Sự</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Trích xuất số CCCD, Họ tên, Ngày sinh, Quê quán từ ảnh 2 mặt, tự động kiểm tra ảnh mờ/lóa và đẩy vào Lark Base</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>Chi phí ~15 VNĐ</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Upload</div>
                        <div className="step-title">Upload Ảnh 2 Mặt CCCD</div>
                        <div className="step-tool"><i className="fa-solid fa-upload"></i> Form Ứng Viên</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: AI Vision</div>
                        <div className="step-title">OCR &amp; Kiểm Tra Chất Lượng</div>
                        <div className="step-tool"><i className="fa-solid fa-eye"></i> Gemini Vision OCR</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: Sync DB</div>
                        <div className="step-title">Đẩy Vào Lark Base Master</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> Lark Base API</div>
                    </div>
                    <div className="timeline-box" style={{"borderColor":"var(--gold)"}}>
                        <div className="step-tag" style={{"color":"var(--gold)"}}>Bước 4: Human Review</div>
                        <div className="step-title">Nhân Sự Đối Chiếu Nhanh</div>
                        <div className="step-tool"><i className="fa-solid fa-user-check"></i> Rà soát 2-3 phút</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 06: KẾ TOÁN (ACCOUNTING) DASHBOARD         */}
        {/*  ==============================================  */}
        <div id="view-dept-acc" className={`view-panel ${activeView === 'view-dept-acc' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-calculator" style={{"color":"#34d399"}}></i> DASHBOARD PHÒNG KẾ TOÁN - TÀI CHÍNH</h2>
                    <p>Commission Engine Nhóm Hàng 1, 2, 3 &amp; Đối Soát Dòng Tiền Bán Hàng / Thu Mua</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task Kế Toán</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">QUỸ HOA HỒNG KỲ 1</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>48.5 Triệu</div>
                    <div className="kpi-sub-text">14 Nhân sự kinh doanh</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐỐI SOÁT NGÂN HÀNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>100% Khớp</div>
                    <div className="kpi-sub-text">Không có chênh lệch</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">THU/CHI HÔM QUA</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>+380 Triệu</div>
                    <div className="kpi-sub-text">Dòng tiền dương</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>61 Giờ</div>
                    <div className="kpi-sub-text">Tự động tính hoa hồng</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CÔNG NỢ QUÁ HẠN (>30D)</div>
                    <div className="kpi-main-val" style={{"color":"var(--red-light)"}}>420 Triệu</div>
                    <div className="kpi-sub-text">5 Điểm bán nhà thuốc</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CHI PHÍ TOOL / BOT</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>0 VNĐ</div>
                    <div className="kpi-sub-text">CSDL chothuoc247.vn</div>
                </div>
            </div>

            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-coins" style={{"color":"#34d399","marginRight":"6px"}}></i> Commission Engine — Tự Động Tính Hoa Hồng Nhóm Hàng 1, 2, 3 Từ CSDL</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Tự động phân nhóm hàng theo tỷ lệ hoa hồng quy định, lập bảng đối soát doanh thu và chuyển Kế toán trưởng &amp; BOD phê duyệt</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>0 VNĐ Chi phí</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Revenue Data</div>
                        <div className="step-title">Kéo Doanh Thu Theo Mã</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> chothuoc247.vn Orders</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: Commission Engine</div>
                        <div className="step-title">Áp Tỷ Lệ Nhóm 1, 2, 3</div>
                        <div className="step-tool"><i className="fa-solid fa-calculator"></i> Matrix Calculator</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: Report Gen</div>
                        <div className="step-title">Lập Bảng Đối Soát Kỳ 1</div>
                        <div className="step-tool"><i className="fa-solid fa-file-excel"></i> Lark Base Export</div>
                    </div>
                    <div className="timeline-box" style={{"borderColor":"var(--gold)"}}>
                        <div className="step-tag" style={{"color":"var(--gold)"}}>Bước 4: Approval</div>
                        <div className="step-title">BOD &amp; KTT Phê Duyệt Chi</div>
                        <div className="step-tool"><i className="fa-solid fa-signature"></i> 1-Click Approve</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 07: KINH DOANH / SALES DASHBOARD           */}
        {/*  ==============================================  */}
        <div id="view-dept-sales" className={`view-panel ${activeView === 'view-dept-sales' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-chart-line" style={{"color":"#4ade80"}}></i> DASHBOARD PHÒNG KINH DOANH / SALES</h2>
                    <p>Theo Dõi Đơn Hàng Nhà Thuốc, Phân Tích Điểm Rơi Doanh Số &amp; Báo Giá 1-Click</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task Sales</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐƠN HÀNG HÔM QUA</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>145 Đơn</div>
                    <div className="kpi-sub-text">Doanh số: 1.45 Tỷ</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TỶ LỆ ĐẠT KPI THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>112%</div>
                    <div className="kpi-sub-text">Vượt tiến độ 12%</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">NHÀ THUỐC ĐẶT HÀNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>210 Điểm</div>
                    <div className="kpi-sub-text">Hoạt động đều đặn</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>38 Giờ</div>
                    <div className="kpi-sub-text">Báo giá 1-Click</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">NHÀ THUỐC CẦN CS</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>95 Điểm</div>
                    <div className="kpi-sub-text">Chưa đặt lại >14 ngày</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TOP NHÀ THUỐC VIP</div>
                    <div className="kpi-main-val" style={{"color":"var(--purple-light)"}}>15 Điểm</div>
                    <div className="kpi-sub-text">Đóng góp 45% doanh số</div>
                </div>
            </div>

            <div className="workflow-step-card">
                <div className="workflow-step-header">
                    <div>
                        <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-bell" style={{"color":"#4ade80","marginRight":"6px"}}></i> Bot Cảnh Báo Nhà Thuốc Chậm Đặt Hàng &amp; Soạn Báo Giá 1-Click</strong>
                        <div style={{"fontSize":"11px","color":"var(--text-muted)","marginTop":"2px"}}>Tự động phát hiện nhà thuốc có chu kỳ đặt hàng bất thường, gợi ý danh mục sản phẩm bổ sung và tạo báo giá gửi Zalo</div>
                    </div>
                    <span style={{"fontSize":"11px","color":"var(--green)","fontWeight":"700","background":"rgba(16, 185, 129, 0.15)","padding":"3px 8px","borderRadius":"4px"}}>0 VNĐ Chi phí</span>
                </div>
                <div className="timeline-grid">
                    <div className="timeline-box">
                        <div className="step-tag">Bước 1: Scan Cycle</div>
                        <div className="step-title">Quét Chu Kỳ Mua Hàng</div>
                        <div className="step-tool"><i className="fa-solid fa-database"></i> chothuoc247.vn Data</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 2: AI Recommendation</div>
                        <div className="step-title">Gợi Ý Danh Mục Thiếu</div>
                        <div className="step-tool"><i className="fa-solid fa-pills"></i> Recommender Engine</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 3: Quote Gen</div>
                        <div className="step-title">Tạo Báo Giá 1-Click</div>
                        <div className="step-tool"><i className="fa-solid fa-file-invoice"></i> PDF/Zalo Template</div>
                    </div>
                    <div className="timeline-box">
                        <div className="step-tag">Bước 4: Sales Action</div>
                        <div className="step-title">Sales Rep Gọi Chăm Sóc</div>
                        <div className="step-tool"><i className="fa-solid fa-phone"></i> Tương tác nhà thuốc</div>
                    </div>
                </div>
            </div>
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 08: SẢN PHẨM / R&D (TECHPHA) DASHBOARD    */}
        {/*  ==============================================  */}
        <div id="view-dept-rnd" className={`view-panel ${activeView === 'view-dept-rnd' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-flask" style={{"color":"#fcd34d"}}></i> DASHBOARD PHÒNG SẢN PHẨM / R&amp;D (TECHPHA)</h2>
                    <p>Cây Tri Thức Hoạt Chất, Tra Cứu Tương Tác Thuốc &amp; Chuẩn Hóa CSDL Dược Điển</p>
                </div>
                <div style={{"display":"flex","gap":"8px"}}>
                    <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')}><i className="fa-solid fa-plus"></i> Giao task R&amp;D</button>
                    <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                </div>
            </div>

            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">MÃ HOẠT CHẤT ĐÃ NẠP</div>
                    <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>1.250 Mã</div>
                    <div className="kpi-sub-text">Dược điển Việt Nam V</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">TIẾN ĐỘ PRJ-TECHPHA</div>
                    <div className="kpi-main-val" style={{"color":"var(--red-light)"}}>42%</div>
                    <div className="kpi-sub-text">Đang chờ CSDL BYT</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">CÂY TRI THỨC TƯƠNG TÁC</div>
                    <div className="kpi-main-val" style={{"color":"var(--blue-light)"}}>3.400 Cặp</div>
                    <div className="kpi-sub-text">Cảnh báo kê đơn</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>50 Giờ</div>
                    <div className="kpi-sub-text">Tra cứu tự động</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">ĐỘ CHÍNH XÁC AI</div>
                    <div className="kpi-main-val" style={{"color":"var(--green)"}}>99.2%</div>
                    <div className="kpi-sub-text">Đã qua Hội đồng duyệt</div>
                </div>
                <div className="kpi-box">
                    <div className="kpi-box-title">MEMORY OPENCLAW</div>
                    <div className="kpi-main-val" style={{"color":"var(--purple-light)"}}>v1.4</div>
                    <div className="kpi-sub-text">Techpha Knowledge</div>
                </div>
            </div>
        </div>

        <div id="view-dept-assist" className={`view-panel ${activeView === 'view-dept-assist' ? 'active' : ''}`}>
            {(() => {
                const kpis = troLyData?.summary_kpis;
                const allDailyLogs = troLyData?.daily_logs || [];
                const availableLogDates = [...new Set(allDailyLogs.map((l) => l.date).filter(Boolean))].sort().reverse();
                const filteredDailyLogs = selectedLogDates.length === 0
                    ? allDailyLogs
                    : allDailyLogs.filter((l) => selectedLogDates.includes(l.date));
                const blockedLogs = filteredDailyLogs.filter((log) => classifyStatus(log.type) === 'blocked');
                const riskySystems = (troLyData?.system_status || []).filter((s) => s.risks && s.risks !== 'Không có');
                const dataSource = troLyData?._source;

                return (
                    <>
                        <div className="dept-header-banner">
                            <div className="dept-title-box">
                                <h2><i className="fa-solid fa-user-tie" style={{"color":"#38bdf8"}}></i> DASHBOARD {troLyData?.department_name?.toUpperCase() || 'BAN TRỢ LÝ'}</h2>
                                <p>
                                    Báo cáo tiến độ &amp; tình trạng hệ thống — cập nhật lúc {troLyData?.updated_at || '—'}
                                    {dataSource === 'sample' && (
                                        troLyData?._error
                                            ? ` (đang dùng dữ liệu mẫu — ${troLyData._error})`
                                            : ' (đang dùng dữ liệu mẫu, chưa gắn link Google Sheet)'
                                    )}
                                </p>
                            </div>
                            <div style={{"display":"flex","gap":"8px"}}>
                                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
                            </div>
                        </div>

                        {!troLyData ? (
                            <div className="workflow-step-card"><div className="workflow-step-header"><span>Đang tải dữ liệu…</span></div></div>
                        ) : (
                            <>
                                <div className="kpi-row-6">
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">TASK TUẦN NÀY</div>
                                        <div className="kpi-main-val" style={{"color":"var(--green)"}}>{kpis?.completed_tasks ?? '—'}/{kpis?.total_tasks_week ?? '—'}</div>
                                        <div className="kpi-sub-text">Đang triển khai: {kpis?.in_progress_tasks ?? 0} • Vướng/Delay: {kpis?.blocked_tasks ?? 0}</div>
                                    </div>
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">TỶ LỆ HOÀN THÀNH</div>
                                        <div className="kpi-main-val" style={{"color":"var(--gold-light)"}}>{kpis?.completion_rate ?? '—'}%</div>
                                        <div className="kpi-sub-text">Trên tổng {kpis?.total_tasks_week ?? '—'} task tuần</div>
                                    </div>
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">SYSTEM UPTIME</div>
                                        <div className="kpi-main-val" style={{"color":"var(--green)"}}>{kpis?.system_uptime || '—'}</div>
                                        <div className="kpi-sub-text">OpenClaw + 9Router</div>
                                    </div>
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">VPS / API STATUS</div>
                                        <div className="kpi-main-val" style={{"color":"var(--cyan)"}}>{kpis?.vps_api_status || '—'}</div>
                                        <div className="kpi-sub-text">Vertex AI &amp; hạ tầng VPS</div>
                                    </div>
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">AI SKILLS ĐANG HOẠT ĐỘNG</div>
                                        <div className="kpi-main-val" style={{"color":"var(--purple-light)"}}>{kpis?.active_ai_skills || '—'}</div>
                                        <div className="kpi-sub-text">Nạp trên OpenClaw Router</div>
                                    </div>
                                    <div className="kpi-box">
                                        <div className="kpi-box-title">TASK ĐANG CHẶN</div>
                                        <div className="kpi-main-val" style={{"color":"var(--red-light)"}}>{kpis?.blocked_tasks ?? 0}</div>
                                        <div className="kpi-sub-text">Cần BOD / quyết định xử lý</div>
                                    </div>
                                </div>

                                <div className="workflow-step-card">
                                    <div className="workflow-step-header">
                                        <div>
                                            <strong style={{"color":"white","fontSize":"13.5px"}}><i className="fa-solid fa-calendar-days" style={{"color":"#38bdf8","marginRight":"6px"}}></i> Nhật Ký Báo Cáo Ngày</strong>
                                        </div>
                                        <DateMultiSelect
                                            options={availableLogDates}
                                            selected={selectedLogDates}
                                            onChange={setSelectedLogDates}
                                            placeholder="Tất cả các ngày"
                                        />
                                    </div>

                                    <div style={{"overflowX":"auto","overflowY":"auto","maxHeight":"420px"}}>
                                        <table style={{"width":"100%","borderCollapse":"collapse","fontSize":"12px"}}>
                                            <thead>
                                                <tr style={{"textAlign":"left","color":"var(--text-muted)","borderBottom":"1px solid var(--border-subtle)"}}>
                                                    <th style={{"padding":"6px 8px","whiteSpace":"nowrap","position":"sticky","top":0,"background":"var(--bg-card)"}}>Ngày</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Trạng thái</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Đầu việc</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Nội dung</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>%</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Dự kiến xong</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Bằng chứng</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Cần ai quyết</th>
                                                    <th style={{"padding":"6px 8px","position":"sticky","top":0,"background":"var(--bg-card)"}}>Hạn cần quyết</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredDailyLogs.map((log, idx) => {
                                                    const st = taskStatusStyle(log.type);
                                                    return (
                                                        <tr key={idx} style={{"borderBottom":"1px solid var(--border-subtle)","verticalAlign":"top"}}>
                                                            <td style={{"padding":"6px 8px","color":"white","whiteSpace":"nowrap"}}>{log.date}</td>
                                                            <td style={{"padding":"6px 8px"}}>
                                                                <span style={{"padding":"2px 8px","borderRadius":"4px","fontWeight":"700","color":st.color,"background":st.bg,"whiteSpace":"nowrap"}}>{log.type}</span>
                                                            </td>
                                                            <td style={{"padding":"6px 8px","color":"white","minWidth":"200px"}}>{log.task}</td>
                                                            <td style={{"padding":"6px 8px","color":"white","minWidth":"260px"}}>{renderMultilineText(log.content)}</td>
                                                            <td style={{"padding":"6px 8px","color":"white"}}>{log.progress_percent}%</td>
                                                            <td style={{"padding":"6px 8px","color":"white","whiteSpace":"nowrap"}}>{log.estimated_completion}</td>
                                                            <td style={{"padding":"6px 8px","color":"white"}}>{renderMultilineText(log.evidence)}</td>
                                                            <td style={{"padding":"6px 8px","color":"white","whiteSpace":"nowrap"}}>{log.decision_required_by}</td>
                                                            <td style={{"padding":"6px 8px","color":"white","whiteSpace":"nowrap"}}>{log.decision_deadline}</td>
                                                        </tr>
                                                    );
                                                })}
                                                {filteredDailyLogs.length === 0 && (
                                                    <tr><td colSpan={9} style={{"padding":"12px 8px","color":"var(--text-muted)"}}>Không có nhật ký nào khớp bộ lọc.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="card-container">
                                    <div className="card-header-bar">
                                        <div className="card-header-title"><i className="fa-solid fa-triangle-exclamation" style={{"color":"var(--red)"}}></i> CẢNH BÁO &amp; ĐIỂM NGHẼN {selectedLogDates.length > 0 ? '(theo ngày đang lọc)' : ''}</div>
                                    </div>
                                    <div className="risk-item-list">
                                        {blockedLogs.map((log, idx) => (
                                            <div className="risk-item-card" key={`log-${idx}`}>
                                                <div className="risk-item-left">
                                                    <div className="risk-icon-box risk-icon-red"><i className="fa-solid fa-triangle-exclamation"></i></div>
                                                    <div className="risk-text-info">
                                                        <div className="title">{log.task} <span style={{"fontWeight":"400","color":"var(--text-muted)","fontSize":"11px"}}>({log.type})</span></div>
                                                        <div className="sub" style={{"color":"white"}}>
                                                            {renderMultilineText(log.content)}
                                                            {log.decision_required_by && <><br/>Chờ quyết định: <strong>{log.decision_required_by}</strong>{log.decision_deadline ? ` • Hạn: ${log.decision_deadline}` : ''}</>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {riskySystems.map((s, idx) => (
                                            <div className="risk-item-card" key={`sys-${idx}`}>
                                                <div className="risk-item-left">
                                                    <div className="risk-icon-box risk-icon-yellow"><i className="fa-solid fa-server"></i></div>
                                                    <div className="risk-text-info">
                                                        <div className="title">{s.system_name}</div>
                                                        <div className="sub">{s.risks}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {blockedLogs.length === 0 && riskySystems.length === 0 && (
                                            <div style={{"padding":"8px","color":"var(--text-muted)","fontSize":"12px"}}>Không có cảnh báo hay điểm nghẽn nào.</div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                );
            })()}
        </div>

        {/*  ==============================================  */}
        {/*  VIEW 09: CÁC VIEW QUẢN TRỊ KHÁC                 */}
        {/*  ==============================================  */}
    </>
  );
}
